// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"18e3ffd3","215":"c4b30f56","513":"6eb77723"}[chunkId] + ".chunk.css";
};